import { render, staticRenderFns } from "./PathwayList.vue?vue&type=template&id=2c1dcde8"
import script from "./PathwayList.vue?vue&type=script&lang=js"
export * from "./PathwayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports